<div class="customer-info">

    <div (click)="onPreviousBtnClicked()" class="ps-back">
        <i class="fa fa-chevron-left"></i>
        Zurück
    </div>


    <div class="title">
        Ihre Anfrage wird direkt durch unseren Projektvertrieb betreut.<br>
        Damit wir den zuständigen Account Manager informieren können, benötigen wir noch folgende Angaben von Ihnen:
    </div>
    <div class="info-elements" bdFxLayoutAlign="start-center">
        <div class="zip" bdFxLayoutAlign="start-center">

            <sc-labeled-input label="PLZ des Kunden*" placeholder="4- oder 5-stellig" class="zip-code"


                              (ngModelChange)="setCustomerInfoZip($event)"
                              name="zipCode" [(ngModel)]="salesConciergeRequest.customerInfo.zip"

            ></sc-labeled-input>
        </div>
        <div class="type" bdFxLayoutAlign="end-center">


            <bd-labeled-select-input class="type" label="Kundentyp*" placeholder="Bitte auswählen"
                                     (ngModelChange)="setCustomerInfoType($event)"
                                     required
                                     [choices]="selects.customerTypeSelector.choices"
                                     [values]="selects.customerTypeSelector.values"
                                     name="customerType" [(ngModel)]="salesConciergeRequest.customerInfo.customerType"
                                     #customerTypeNgModel="ngModel">

            </bd-labeled-select-input>


        </div>
    </div>


</div>
